import { InfoCard } from '../../../../../../components/info-card';
import { Icon } from '@/new/components/icon';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/new/components/shadcn/dialog';

export function FolderDeduplicationInfoDialog() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="text-gray-400 hover:text-gray-600">
          <Icon className="lucide--info size-3.5" />
        </button>
      </DialogTrigger>
      <DialogContent className="overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Include Deduplicated Files</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm text-gray-600">
          <p>When enabled, files within selected folders that were deduplicated will appear in the list.</p>

          {/* Graphic: Folder 1 owns Contract.pdf; Folder 2 has it as a duplicate.
              Selecting Folder 2 with this option on still includes Contract.pdf. */}
          <div className="mx-auto my-10 mt-8 w-3/4 overflow-hidden rounded-lg border bg-gray-50 px-4 pt-4 pb-2">
            <div className="flex items-stretch gap-4">
              {/* Folder 1 — original location of Contract.pdf */}
              <div className="h-fit flex-1 rounded-lg border border-gray-200 bg-white p-3 px-3.5 pb-2.5">
                <div className="mb-1.5 flex items-center gap-2 text-gray-600">
                  <Icon className="lucide--folder text-gray-400" />
                  <span className="text-xs font-medium">Folder 1</span>
                </div>
                <ul className="space-y-1.5">
                  <li className="flex items-center gap-2 text-xs text-gray-800">
                    <span className="ml-2 font-medium">Contract.pdf</span>
                  </li>
                </ul>
              </div>

              {/* Folder 2 — duplicate upload (selected: blue outline) */}
              <div className="flex-1 rounded-lg border border-blue-300 bg-white p-3 px-3.5 pb-2.5 ring-blue-100">
                <div className="mb-1 flex items-center gap-2 text-gray-600">
                  <Icon className="lucide--folder text-gray-400" />
                  <span className="text-xs font-medium">Folder 2</span>
                </div>
                <ul className="space-y-1.5">
                  <li className="flex items-center gap-2 text-xs text-gray-800">
                    <span className="ml-2 font-medium text-gray-400/80">Contract.pdf</span>
                    <span className="shrink-0 rounded border border-amber-100 bg-amber-50 px-1.25 py-px text-[11px] text-amber-600">
                      Duplicate
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Outcome row */}
            <div className="mt-2 flex items-center gap-1 px-1 py-2 text-gray-700">
              <span>Selecting Folder 2 includes</span>
              <span className="font-medium">Contract.pdf</span>
              <Icon className="lucide--check ml-1 h-3.5 w-3.5 text-green-600" />
            </div>
          </div>

          <p className="text-gray-600">
            <span className="font-medium">Contract.pdf</span> was uploaded inside Folder 2 but it matched an existing
            copy in Folder 1, so it was deduplicated and removed. With this option enabled, selecting Folder 2 still
            selects <span className="font-medium">Contract.pdf</span>.
          </p>

          <InfoCard className="mt-6 text-xs">
            <p className="mt-px">
              This will only apply to files/folders uploaded after <strong>30th April 2026.</strong>
            </p>
          </InfoCard>
        </div>
      </DialogContent>
    </Dialog>
  );
}
